import { useState } from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import FreeInspection from './components/FreeInspection';
import Warranty from './components/Warranty';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <Services />
      <FreeInspection />
      <Warranty />
      <About />
      <Contact />
      <Footer />
    </div>
  );
}
